import { crudOperations } from '../../api';

// Get jobs for a franchisee
export const getJobs = async (franchiseeId, {
  page = 1,
  limit = 50,
  status,
  search,
  service_type,
  branch_id,
  customer_id,
  date_from,
  date_to,
  sortBy = 'scheduled_date',
  sortOrder = 'ASC'
} = {}) => {
  try {
    const params = { page, limit, sortBy, sortOrder };
    if (search) params.search = search;
    if (status) params.status = status;
    if (service_type) params.service_type = service_type;
    if (branch_id) params.branch_id = branch_id;
    if (customer_id) params.customer_id = customer_id;
    if (date_from) params.date_from = date_from;
    if (date_to) params.date_to = date_to;

    const response = await crudOperations.get(`/jobs/${franchiseeId}`, params);
    return response.data;
  } catch (error) {
    console.error('Get jobs error:', error);
    throw error;
  }
};

// Get specific job with full details
export const getJob = async (franchiseeId, jobId) => {
  try {
    const response = await crudOperations.get(`/jobs/${franchiseeId}/${jobId}`);
    return response.data;
  } catch (error) {
    console.error('Get job error:', error);
    throw error;
  }
};

// Create new job
export const createJob = async (franchiseeId, jobData) => {
  try {
    const response = await crudOperations.post(`/jobs/${franchiseeId}`, jobData);
    return response.data;
  } catch (error) {
    console.error('Create job error:', error);
    throw error;
  }
};

// Update job
export const updateJob = async (franchiseeId, jobId, jobData) => {
  try {
    const response = await crudOperations.put(`/jobs/${franchiseeId}/${jobId}`, jobData);
    return response.data;
  } catch (error) {
    console.error('Update job error:', error);
    throw error;
  }
};

// Delete job
export const deleteJob = async (franchiseeId, jobId) => {
  try {
    const response = await crudOperations.delete(`/jobs/${franchiseeId}/${jobId}`);
    return response.data;
  } catch (error) {
    console.error('Delete job error:', error);
    throw error;
  }
};

// Get all documents (invoices, treatment reports, estimates) linked to a job
export const getJobDocuments = async (franchiseeId, jobId) => {
  try {
    const response = await crudOperations.get(`/jobs/${franchiseeId}/${jobId}/documents`);
    return response.data;
  } catch (error) {
    console.error('Get job documents error:', error);
    throw error;
  }
};

// Get notes for a job
export const getJobNotes = async (franchiseeId, jobId) => {
  try {
    const response = await crudOperations.get(`/jobs/${franchiseeId}/${jobId}/notes`);
    return response.data;
  } catch (error) {
    console.error('Get job notes error:', error);
    throw error;
  }
};

// Create a new note for a job
export const createJobNote = async (franchiseeId, jobId, noteText) => {
  try {
    const response = await crudOperations.post(`/jobs/${franchiseeId}/${jobId}/notes`, { note_text: noteText });
    return response.data;
  } catch (error) {
    console.error('Create job note error:', error);
    throw error;
  }
};

// Create a reminder for a job
export const createJobReminder = async (franchiseeId, jobId, noteText, reminderDatetime) => {
  try {
    const response = await crudOperations.post(`/jobs/${franchiseeId}/${jobId}/notes`, {
      note_text: noteText,
      is_reminder: true,
      reminder_datetime: reminderDatetime
    });
    return response.data;
  } catch (error) {
    console.error('Create job reminder error:', error);
    throw error;
  }
};

// Toggle reminder status (active/done)
export const toggleNoteReminderStatus = async (franchiseeId, jobId, noteId, newStatus) => {
  try {
    const response = await crudOperations.put(`/jobs/${franchiseeId}/${jobId}/notes/${noteId}`, {
      reminder_status: newStatus
    });
    return response.data;
  } catch (error) {
    console.error('Toggle reminder status error:', error);
    throw error;
  }
};

// Delete a job note
export const deleteJobNote = async (franchiseeId, jobId, noteId) => {
  try {
    const response = await crudOperations.delete(`/jobs/${franchiseeId}/${jobId}/notes/${noteId}`);
    return response.data;
  } catch (error) {
    console.error('Delete job note error:', error);
    throw error;
  }
};

// Upload job attachments
export const uploadAttachments = async (franchiseeId, jobId, files) => {
  try {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });

    const response = await crudOperations.upload(`/jobs/${franchiseeId}/${jobId}/attachments`, formData);
    return response.data;
  } catch (error) {
    console.error('Upload attachments error:', error);
    throw error;
  }
};